// =============================================================================
// memoiresPersonne.js : les mémoires de module LIÉES À LA PERSONNE connectée
// (relecture de la Médiathèque L17.2b-c, 04/10/2026).
// -----------------------------------------------------------------------------
// Une réponse de serveur gardée en mémoire de page (la une de Ma semaine, les
// albums des séances) ne vaut que pour la personne qui l'a demandée : elle
// porte des titres, des drapeaux d'équipe et des liens d'affichage d'environ
// une heure qu'un autre compte n'a pas le droit de voir. Or la déconnexion ne
// recharge pas la page : sur un iPad ou un poste partagé, la personne suivante
// se connecte dans le même onglet.
// Deux défenses, toujours ensemble :
//   - chaque mémoire est MARQUÉE de la personne connectée (personneConnectee :
//     la session réelle, celle que le serveur sert, jamais l'aperçu « Voir
//     comme ») et ignorée si elle diffère ;
//   - la connexion et la déconnexion (App.jsx, loginAramis et logoutAramis)
//     vident toutes les mémoires inscrites (oublierMemoiresPersonne).
// Module minuscule et sans dépendance : le bundle principal l'importe sans
// tirer les écrans de la Médiathèque, qui s'y inscrivent à leur chargement.
// =============================================================================

const oublis = new Set();

/** Identifiant de la session réelle (stockée à la connexion), ou null. */
export function personneConnectee() {
  let brut = null;
  try { brut = localStorage.getItem("aramis_session"); } catch { brut = null; }
  if (!brut) {
    try { brut = sessionStorage.getItem("aramis_session"); } catch { brut = null; }
  }
  if (!brut) return null;
  try {
    const s = JSON.parse(brut);
    return s && typeof s.id === "string" && s.id ? s.id : null;
  } catch {
    return null;
  }
}

/** Une mémoire de module s'inscrit : elle sera vidée à chaque changement de personne. */
export function inscrireMemoirePersonne(oublier) {
  if (typeof oublier === "function") oublis.add(oublier);
  return () => oublis.delete(oublier);
}

/** Connexion, déconnexion : toutes les mémoires inscrites sont vidées. Ne jette jamais. */
export function oublierMemoiresPersonne() {
  for (const oublier of [...oublis]) {
    try { oublier(); } catch { /* une mémoire en défaut ne retient pas les autres */ }
  }
}
